import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ListChecks, ChevronRight, X } from "lucide-react";
import { myTodo, dismissTodo } from "@/lib/applyApi";

// Derived server-side from existing account / application / contract / Ad Template data; hidden when nothing is left.
export function TodoCard() {
  const navigate = useNavigate();
  const [d, setD] = useState(null);
  const load = useCallback((bg) => myTodo(bg === true).then(setD).catch(() => {}), []);
  useEffect(() => {
    load();
    const t = setInterval(() => load(true), 15000);
    const onFocus = () => load(true);
    window.addEventListener("focus", onFocus);
    return () => { clearInterval(t); window.removeEventListener("focus", onFocus); };
  }, [load]);
  const dismiss = (id) => dismissTodo(id).then(() => load(true)).catch(() => {});
  if (!d || !d.count) return null;
  return (
    <section data-testid="todo-section" className="mb-6 rounded-2xl border border-amber-300 bg-white p-3 sm:p-4 animate-in fade-in duration-300">
      <h2 className="flex items-center gap-2 text-lg font-semibold text-stone-900 mb-3">
        <ListChecks className="h-5 w-5 text-amber-800" />To Do
        <span data-testid="todo-count" className="text-sm font-medium text-stone-500">— {d.count} item{d.count > 1 ? "s" : ""} remaining</span>
      </h2>
      <ul className="divide-y divide-stone-100">
        {d.tasks.map((t) => (
          <li key={t.id} data-testid={`todo-item-${t.id}`} className="flex items-center gap-3 py-2.5">
            <span className={`h-2 w-2 shrink-0 rounded-full ${t.optional ? "bg-stone-200" : t.priority < 60 ? "bg-amber-600" : "bg-stone-400"}`} />
            <div className="min-w-0 flex-1">
              <p data-testid={`todo-title-${t.id}`} className="text-sm font-semibold text-stone-900">{t.title}{t.horse_name && <span className="font-normal text-stone-600"> — {t.horse_name}</span>}</p>
              {t.detail && <p data-testid={`todo-detail-${t.id}`} className="text-xs text-stone-500 mt-0.5">{t.detail}</p>}
            </div>
            <button type="button" data-testid={`todo-action-${t.id}`} onClick={() => navigate(t.href)}
              className="shrink-0 inline-flex items-center gap-1 h-9 px-3 rounded-full bg-amber-800 text-white text-xs font-semibold hover:bg-amber-900 transition-colors">
              {t.action}<ChevronRight className="h-3.5 w-3.5" />
            </button>
            {t.optional && (
              <button type="button" data-testid={`todo-dismiss-${t.id}`} onClick={() => dismiss(t.id)} aria-label="Dismiss" title="No thanks"
                className="shrink-0 h-9 w-9 inline-flex items-center justify-center rounded-full text-stone-400 hover:bg-stone-100 hover:text-stone-700 transition-colors">
                <X className="h-4 w-4" />
              </button>
            )}
          </li>
        ))}
      </ul>
    </section>
  );
}
